import React from "react";

export const tooltips = {
    clientType: (
        <>
            <p>
                <b>Propietario:</b> Si eres dueño de una casa
                <br />o departamento
            </p>
            <br />
            <p>
                <b>Inquilino:</b> Si alquilas un cuarto, casa
                <br />o departamento
            </p>
        </>
    ),
    whichEnsure: (
        <>
            <p>
                <b>Casa + cosas:</b>
                <br />
                Puedes proteger la estructura más todas las cosas y bienes de alto valor
                que están dentro de tu casa o departamento.
            </p>
            <br />
            <p>
                <b>Casa:</b>
                <br />
                Puedes proteger la estructura de tu casa o departamento esto incluye la
                cochera, el depósito, mamparas, ventanas, instalaciones fijas y muebles
                empotrados.
            </p>
            <br />
            <p>
                <b>Cosas:</b>
                <br />
                Puedes proteger las cosas de uso doméstico (muebles, televisores,
                electrodomésticos, etc) y bienes de alto valor (joyas, laptops,
                bicicletas, etc) que tienes en tu casa o departamento.
            </p>
        </>
    ),
};
